var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex flex-col justify-center items-center gap-2"},[_c('feather-icon',{attrs:{"icon":"AlertTriangleIcon","svgClasses":"h-10 w-10 text-grey"}}),_c('p',{staticClass:"text-grey font-medium"},[_vm._v(_vm._s(_vm.$t('You do not have permission to') + ' ' + _vm.action))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }